import { Loader } from "@circle-react-uikit/Loader";

import { t } from "@/i18n-js/instance";

interface ProcessingPaymentLoaderProps {
  message?: string;
  shouldShow: boolean;
}

export const ProcessingPaymentLoader = ({
  shouldShow,
  message,
}: ProcessingPaymentLoaderProps) => {
  if (!shouldShow) {
    return null;
  }

  return (
    <Loader
      variant="fullscreen"
      message={message || t("paywalls.checkout.bnpl_processing")}
    />
  );
};
